<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Insured Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="filterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header"><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="filterForm"
                              v-model="filters.insdRefNo"
                              :label="labels.insdRefNo"
                              :error-messages="errors.collect('insdRefNo')"
                              data-vv-name="insdRefNo"
                              :data-vv-as="labels.insdRefNo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="filterForm"
                              v-model="filters.fullName"
                              :label="labels.fullName"
                              :error-messages="errors.collect('fullName')"
                              data-vv-name="fullName"
                              :data-vv-as="labels.fullName"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                v-bind:options.sync="paginationInsured"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItemsInsured"
                :loading="loading"
                class="elevation-1"
                :no-data-text="noDataText"
                item-key="key"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'insured')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'insured')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  props: {
    insdRef: String
  },
  data() {
    return {
      labels: {
        insdRefNo: 'Insured Reference',
        fullName: 'Full Name'
      },
      filters: {
        insdRefNo: undefined,
        fullName: undefined
      },
      headers: [
        { text: 'Insured Reference', value: 'insdRefNo' },
        { text: 'Full Name', value: 'fullName' }
      ],
      selected: [],
      insureds: [],
      totalItemsInsured: 0,
      paginationInsured: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function () {
      // this.doInit()
    },
    'paginationInsured': function (value) {
      this.fetchData()
    }
  },
  methods: {
    async fetchData() {
      this.insureds = this.insdRef.split(',')
      const apiUrl = this.menu.insuredList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationInsured
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }

          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationInsured.sortBy, this.paginationInsured.sortDesc)
          )
          if (result.data) {
            this.totalItemsInsured = result.data.totalElements
            this.items = []
            this.selectedItems = []

            const { data } = result.data
            if (data) {
              data.map((param) => {
                const convertList = {
                  key: param.insdRefNo,
                  insdRefNo: param.insdRefNo,
                  fullName: param.fullName
                }
                this.items.push(convertList)

                if (this.checkedItems.includes(param.insdRefNo)) {
                  const selectedInsuredList = {
                    key: param.insdRefNo,
                    insdRefNo: param.insdRefNo,
                    fullName: param.fullName
                  }
                  this.selectedItems.push(selectedInsuredList)
                }
              })
            }

            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.insdRefNo = null
      this.filters.fullName = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filterForm').then((result) => {
        if (result) {
          // Reset to page 1
          this.paginationInsured.page = 1
          this.fetchData()
        }
      })
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin, commonAjaxMixin]
}
</script>
